import evaluationShopCard from "./evaluationShopCard"
export default evaluationShopCard;
